import React from 'react';
import SIM from '../../../sim/core';

export default class BasketBuyingLoader extends React.Component {
  static propTypes = {
    isActive: React.PropTypes.bool
  };

  render () {
    if (!this.props.isActive) {
      return false;
    }

    return (
      <div className="buyingloader__bg">
        <SIM.Views.Spinner className="buyingloader" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/edp/buyingloader/index.js